// The sentence a "Needs your eyes" row shows when it is there because of a
// subscription, not a receipt match. Pure so the wording has a test of its own.

import type { ReconTxn } from './types';

const money = (n: unknown) => `$${Math.abs(Number(n) || 0).toFixed(2)}`;

/** Null when the charge carries neither a hint nor a proposal. A hint wins: it is the stronger fact. */
export function recurringSentence(txn: ReconTxn): string | null {
  const h = txn.recurring_hint;
  if (h) {
    if (h.reason === 'amount_changed') return `Remembered subscription, usually ${money(h.last_amount)}. This one is ${money(txn.amount)}.`;
    if (h.reason === 'sibling_declined') return 'You called another charge from this vendor a separate purchase. Is this one the subscription?';
    return 'Second charge from this subscription in this period.';
  }
  const p = txn.recurring_proposal;
  if (p) {
    const n = p.seen_in_periods;
    return `Looks like a subscription: seen in ${n} earlier period${n === 1 ? '' : 's'}${p.same_amount ? ', same amount each time' : ''}.`;
  }
  return null;
}
